module.exports = __webpack_public_path__ + "img/cabrel_20s_decembre_2021.5296bf36.jpg";